import api from './client';

// Allow time for the API to wake up, but do not leave the login form waiting forever.
const LOGIN_TIMEOUT_MS = 60000;

export async function login(username, password) {
  const { data } = await api.post('/api/auth/login', { username, password }, {
    timeout: LOGIN_TIMEOUT_MS,
  });
  return data;
}

export async function verifyToken(token) {
  await api.get('/api/auth/verify', {
    headers: { Authorization: `Bearer ${token}` },
  });
}
